import API from './api';

/**
 * Actions
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

export const UPDATE_PROJECT_TITLE = 'UPDATE_PROJECT_TITLE';

export function updateProjectTitle(buildIndex, title) {
    return {
        type: UPDATE_PROJECT_TITLE,
        payload: {
            buildIndex,
            title: `${title}-${Math.floor(Math.random() * (50000 - 10000) + 10000)}`,
        },
        // random 5 digit number 10,000 - 50,000
    };
}

export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';

export function toggleNavigation() {
    return {
        type: TOGGLE_NAVIGATION,
        payload: null,
    };
}

export const HIDE_TOAST = 'HIDE_TOAST';

export function hideToast() {
    return {
        type: HIDE_TOAST,
        payload: null,
    };
}

//
// Select a section, receive top level categories for that section
//
export const SELECTING_SECTION = 'SELECTING_SECTION';
export const RECEIVED_CATEGORIES = 'RECEIVED_CATEGORIES';

export function selectSection(section) {
    return async (dispatch) => {
        dispatch({
            type: SELECTING_SECTION,
            payload: section,
        });

        const categories = await API.getCategories(section);
        dispatch(receivedCategories(categories));
    };
}

function receivedCategories(categories) {
    return {
        type: RECEIVED_CATEGORIES,
        payload: categories,
    };
}

// Fetch and save config to redux
export const SET_CONFIG = 'SET_CONFIG';
export function getConfig() {
    return async (dispatch) => {
        const config = await API.getConfig();
        dispatch({
            type: SET_CONFIG,
            payload: config,
        });
    };
}

//
// Select a section & category, receive products for that section & category
//
export const SELECTING_CATEGORY = 'SELECTING_CATEGORY';
export const RECEIVED_PRODUCTS = 'RECEIVED_PRODUCTS';
export const SET_AFTER_CURSOR = 'SET_AFTER_CURSOR';
export const SET_CURRENT_FILTERS = 'SET_CURRENT_FILTERS';
export const SET_LOADING_TRUE = 'SET_LOADING_TRUE';

export function selectSectionAndCategory(category, filters, skintone) {
    // console.log('%c Fetch products, start : ', 'color: #47f953; font-size: 18px;', new Date(Date.now()));
    // console.log('selectSectionAndCategory: ', { category, filters, skintone });
    return async (dispatch) => {
        dispatch({
            type: SELECTING_SECTION,
            payload: category.id,
        });

        dispatch({
            type: SELECTING_CATEGORY,
            payload: category,
        });

        dispatch({
            type: SET_CURRENT_FILTERS,
            payload: filters,
        });

        const prods = await API.getProducts(category.id, category.handle, filters, null, skintone);
        const prodAttr = [];
        const prodAttrProcessed = [];
        const { products, hasNextPage } = prods;

        products?.forEach((product) => {
            const prodIdParsed = product.node.id.split('/').pop();
            prodAttr.push([product.node.id, API.getProductAttribute(prodIdParsed)]);
        });

        prodAttr.forEach((productAttribute) => {
            setTimeout(() => {
                productAttribute[1].then((result_1) => {
                    prodAttrProcessed.push(result_1.option_product);
                });
            }, 750);
        });

        dispatch({
            type: SET_AFTER_CURSOR,
            payload: {
                afterCursor: products ? products[products.length - 1]?.cursor : false,
                hasNextPage,
            },
        });

        dispatch(receivedProducts(products, prodAttrProcessed));
    };
}

export function loadMoreProducts(activeSection, activeHandle, afterCursor, currentProducts, filters, skintone) {
    // console.log('%c Fetch products, start load more : ', 'color: #47f953; font-size: 18px;', new Date(Date.now()));

    return async (dispatch) => {
        dispatch({
            type: SET_LOADING_TRUE,
        });

        const prods = await API.getProducts(activeSection, activeHandle, filters, afterCursor, skintone);
        const prodAttr = [];
        const prodAttrProcessed = [];
        const { products, hasNextPage } = prods;

        products?.forEach((product) => {
            const prodIdParsed = product.node.id.split('/').pop();
            prodAttr.push([product.node.id, API.getProductAttribute(prodIdParsed)]);
        });

        prodAttr.forEach((productAttribute) => {
            setTimeout(() => {
                productAttribute[1].then((result_1) => {
                    prodAttrProcessed.push(result_1.option_product);
                });
            }, 750);
        });

        dispatch({
            type: SET_AFTER_CURSOR,
            payload: {
                afterCursor: products ? products[products.length - 1]?.cursor : false,
                hasNextPage,
            },
        });

        if (products.length > 0) {
            dispatch(receivedProducts(products, prodAttrProcessed, currentProducts));
        }
    };
}

function receivedProducts(products, prodAttrProcessed, currentProducts = null) {
    const prods = products;
    const options = prodAttrProcessed;

    // console.log('%c Fetch products, receivedProducts... : ', 'color: blue; font-size: 16px;', {
    //     products,
    //     prodAttrProcessed,
    //     currentProducts,
    //     prods,
    //     options,
    // }, new Date(Date.now()));

    return async (dispatch) => {
        setTimeout(() => {
            for (let i = 0, n = prods?.length; i < n; i += 1) {
                prods[i].boldProductOptions = Object.entries(options)[i];
            }

            dispatch({
                type: RECEIVED_PRODUCTS,
                payload: currentProducts ? [...currentProducts, ...prods] : prods,
            });
        }, 750);

        // console.log('%c Fetch products, end... : ', 'color: #f94747; font-size: 18px;', new Date(Date.now()));
    };
}

//
// Select a product for a section
//
export const SELECTING_PRODUCT = 'SELECTING_PRODUCT';
export const RECEIVED_PRODUCT_DETAILS = 'RECEIVED_PRODUCT_DETAILS';

export function customiseProduct(product /*attributes, addons*/) {
    return async (dispatch) => {
        const prodIdParsed = product.id.split('/').pop();
        const productR = await API.getProduct(prodIdParsed);
        product = productR.product;

        dispatch({
            type: SELECTING_PRODUCT,
            payload: product,
        });

        // "gid://shopify/Product/3163778646080"

        const [variations, product_attributes, terms] = await Promise.all([
            API.getVariations(prodIdParsed, product.handle),
            API.getProductAttribute(prodIdParsed),
            API.getAttributeTerms(prodIdParsed, prodIdParsed),
        ]);

        return dispatch(receivedProductDetails(product, variations, product_attributes, terms));
    };
}

function receivedProductDetails(product, variations, product_attribute, attributeTerms) {
    return {
        type: RECEIVED_PRODUCT_DETAILS,
        payload: {
            product,
            variations,
            product_attribute,
            attributeTerms,
        },
    };
}

export const SELECT_PRODUCT = 'SELECT_PRODUCT';

export function selectProduct(buildIndex, product, attributes, addons, product_attribute, productFormJsonValues) {
    // attributes contains the actual variant + variant image <<<
    return {
        type: SELECT_PRODUCT,
        payload: {
            buildIndex,
            product,
            attributes,
            addons,
            product_attribute,
            productFormJsonValues,
        },
    };
}

export const SELECT_NAMED_PRODUCT = 'SELECT_NAMED_PRODUCT';

export function selectNamedProduct(
    buildIndex,
    product,
    attributes,
    addons,
    product_attribute,
    product_category,
    productFormJsonValues
) {
    // attributes contains the actual variant + variant image <<<
    return {
        type: SELECT_NAMED_PRODUCT,
        payload: {
            buildIndex,
            product,
            attributes,
            addons,
            product_attribute,
            product_category,
            productFormJsonValues,
        },
    };
}

//
// Edit a product
//
export const EDIT_PRODUCT = 'EDIT_PRODUCT';

export function editProduct(sectionId, product) {
    return {
        type: EDIT_PRODUCT,
        payload: { sectionId, product },
    };
}

//
// Remove a product
//
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';

export function removeProduct(buildIndex, sectionId) {
    return (dispatch) => {
        if (sectionId === 'bodies') {
            dispatch(
                setTorsoText(buildIndex, {
                    frontText: '',
                    backText: '',
                })
            );
        }

        dispatch(doRemove(buildIndex, sectionId));
    };
}

function doRemove(buildIndex, sectionId) {
    return {
        type: REMOVE_PRODUCT,
        payload: { buildIndex, sectionId },
    };
}

//
// Buy
//
export const BUYING = 'BUYING';
export const BOUGHT = 'BOUGHT';
export const ERROR_BUYING = 'ERROR_BUYING';
export const RESET_ERROR_BUYING = 'RESET_ERROR_BUYING';
export const PROJECT_ADDED_TO_CART = 'PROJECT_ADDED_TO_CART';
export const RESET_ADDED_PROJECTS = 'RESET_ADDED_PROJECTS';

export function buy(selectedBuilds) {
    return async (dispatch /*getState*/) => {
        dispatch({
            type: BUYING,
        });

        // reset alerts
        dispatch(resetErrorOnBuy());
        dispatch(resetAddedProjects());

        const errors = [];
        console.log('selectedBuilds: ', selectedBuilds);
        try {
            for (let i = 0; i < selectedBuilds.length; i++) {
                const selectedBuild = selectedBuilds[i];
               
                const res = await API.buy(
                    selectedBuild.selected,
                    selectedBuild.projectTitle,
                    selectedBuild.skintone
                );

                // 442: error
                if (res.status === 422) {
                    const projectTitle = selectedBuild.projectTitle;

                    // Get the product that is out of stock (There are two different error messages that can be returned here)
                    let productOutOfStock; 
                    if (res.message && res.message.startsWith('The product')) {
                        productOutOfStock = res.message.split("'")[1];
                    } else if (res.message && res.message.startsWith("You can't add more")) {
                        productOutOfStock = res.message.split("You can't add more")[1].split("to the cart")[0].trim();
                    }

                    errors.push({productOutOfStock, projectTitle});

                    
                } else if (res.status === 'too_many_requests') {
                    dispatch({
                        type: ERROR_BUYING,
                        payload: {
                            errorMessage: ['Sorry, we are currently experiencing a high volume of traffic. Please try again later.'],
                        },
                    });
                } else if (res.status === 200 || res.status === undefined) {
                    // 200: Success
                    // We store the names of the successfully added projects in case there is an error.
                    // These are displayed next to the error message
                    dispatch(projectAddedToCart(selectedBuild.projectTitle));
                    dispatch(removeSelectedBuild(selectedBuild));
                } 
            } 

            if (errors.length > 0) {
                let errorMessage = [];
                if (errors.length === 1 ) {
                    errorMessage.push(`So sorry! ${errors[0].productOutOfStock.split('-')[0].trim()} is now out of stock. So your project ${errors[0].projectTitle} cannot be added to your basket. Please go back, remove this item from your project and try again.`);
                }  else {

                    errorMessage.push('So sorry! The following products are now out of stock. Please go back, remove these items from your project and try again.');
                    
                    for (let i = 0; i < errors.length; i++) {
                        errorMessage.push( `- ${errors[i].productOutOfStock.split('-')[0].trim()} from project ${errors[i].projectTitle}`);
                    }
                }

                dispatch({
                    type: ERROR_BUYING,
                    payload: {
                        errorMessage,
                    },
                });
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error(error);
            console.error('fail to add to cart');
        }

        // Only redirect if there are no errors
 
        dispatch(bought());
     
    };
}

function bought() {
    return {
        type: BOUGHT,
        payload: null,
    };
}

export function resetErrorOnBuy() {
    return {
        type: RESET_ERROR_BUYING,
        payload: null,
    };
}

//
// Start
//
export const START = 'START';

export function start() {
    return {
        type: START,
        payload: null,
    };
}

//
// Reset
//
export const RESET = 'RESET';

export function reset() {
    return {
        type: RESET,
        payload: null,
    };
}

//
// Set skin tone filter
//
export const SET_SKIN_TONE = 'SET_SKIN_TONE';

export function setSkinTone(buildIndex, skintone) {
    return {
        type: SET_SKIN_TONE,
        payload: { buildIndex, skintone },
    };
}

//
// Set active filter
//
export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';

export function setActiveFilterButton(filter) {
    return {
        type: SET_ACTIVE_FILTER,
        payload: filter,
    };
}

//
// Set torso text
//
export const SET_TORSO_TEXT = 'SET_TORSO_TEXT';

export function setTorsoText(buildIndex, torsoText) {
    return {
        type: SET_TORSO_TEXT,
        payload: { buildIndex, torsoText },
    };
}

export const SET_TORSO_OVERLAY = 'SET_TORSO_OVERLAY';

export function setTorsoOverlay(buildIndex, torsoOverlays) {
    return {
        type: SET_TORSO_OVERLAY,
        payload: { buildIndex, torsoOverlays },
    };
}

export const SET_CURRENT_BUILD_INDEX = 'SET_CURRENT_BUILD_INDEX';

export function setCurrentBuildIndex(buildIndex) {
    return {
        type: SET_CURRENT_BUILD_INDEX,
        payload: { buildIndex },
    };
}

export const REMOVE_BUILD = 'REMOVE_BUILD';

export function removeBuild(buildIndex) {
    return {
        type: REMOVE_BUILD,
        payload: { buildIndex },
    };
}

export const REMOVE_SELECTED_BUILD = 'REMOVE_SELECTED_BUILD';

export function removeSelectedBuild(selectedBuild) {
    return {
        type: REMOVE_SELECTED_BUILD,
        payload: { selectedBuild },
    };
}

export function projectAddedToCart(projectTitle) {
    return {
        type: PROJECT_ADDED_TO_CART,
        payload: { projectTitle },
    };
}

export function resetAddedProjects() {
    return {
        type: RESET_ADDED_PROJECTS,
        payload: null,
    };
}

export const ADD_BUILD = 'ADD_BUILD';

export function addBuild(init) {
    return {
        type: ADD_BUILD,
        payload: init,
    };
}
